// src/components/Download.js
import React from 'react';
import logo from "../assets/logo air.png";

const Download = () => {
  return (
    <div
      id="download"
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        padding: '20px'
      }}
    >
      <div
        style={{
          textAlign: 'center',
          color: 'black',
          padding: '40px 20px',
          borderRadius: '20px',
          backgroundColor: 'white',
          width: '100%',
          maxWidth: '400px',
        }}
      >
        <img
          src={logo}
          alt="Airflex Logo"
          style={{
            height: '180px',
            margin: '0 auto',
            display: 'block',
            maxWidth: '100%'
          }}
        />
        <p style={{ fontSize: '0.8rem', margin: '1rem 0' }}>
          At Airflex RSA, your car is not just a car — it’s a statement.
        </p>
        <h2 style={{ fontSize: '1.5rem' }}>Download Our App</h2>
        <p style={{ fontSize: '1rem' }}> Airflex Suspension App</p>

        <a
          href="/AIRFLEX.apk"
          download
          style={{
            display: 'inline-block',
            marginTop: '1rem',
            padding: '10px 20px',
            backgroundColor: 'red',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '5px',
            fontSize: '1rem'
          }}
        >
          Download 
        </a>
      </div>
    </div>
  );
};

export default Download;
